/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : ViewTestCaseArtifact.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import CustomDataGridV2 from "../../../components/customComponentsV2/common/datagrid/CustomDataGridV2";
import CustomButtonV2 from "../../../components/customComponentsV2/common/button/CustomButtonV2";
import { convertUtcToTimeZone } from "../../../utils/convertUtcToTimeZone";
import { useSelector } from "react-redux";
import { componentStyle } from "../../../config/appTheme";
import ViewImage from "./ViewImage";
import CustomSearchFilterV2 from "../../../components/customComponentsV2/common/searchBar/CustomSearchFilterV2";

function ViewTestCaseArtifact({
  selectedTicketsTableRowData,
  setSelectedTicketsTableRowData,
}) {
  const [openViewFilesDialog, setOpenViewFilesDialog] = useState(false);
  const [selectedTestCaseArtifactData, setSelectedTestCaseArtifactData] =
    useState(null);
  const [tableRowsDataArtifact, setTableRowsDataArtifact] = useState([]);
  const [filteredTestCase, setFilteredTestCase] = useState([]);
  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(10);
  const profileDetails = useSelector((store) => store.profileReducer);
  useEffect(() => {
    console.log(
      "---selectedTicketsTableRowData---",
      selectedTicketsTableRowData?.artefact_details,
    );
    const modifiedTestCaseArtifacts =
      selectedTicketsTableRowData?.artefact_details
        ?.filter((data) => data.artefact_type === "RUN")
        ?.map((tcArt, index) => ({
          ...tcArt,
          id: index + 1,
          executed_at_tz: convertUtcToTimeZone(
            tcArt?.executed_at,
            profileDetails?.profile?.profile?.region,
          ),
        }));
    setTableRowsDataArtifact(modifiedTestCaseArtifacts);
  }, [selectedTicketsTableRowData, profileDetails?.profile?.profile?.region]);
  const COLUMNS_ARTIFACT = [
    {
      field: "id",
      headerName: "S.No",
      minWidth: 60,
      maxWidth: 80,
      filterable: false,
      sortable: false,
    },
    {
      field: "manual_test_case_id",
      headerName: "Test Case ID",
      flex: 1,
      minWidth: 120,
    },
    { field: "run_id", headerName: "Run Id", flex: 1, minWidth: 120 },
    {
      field: "result",
      headerName: "Status",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => (
        <Typography
          sx={{
            ...componentStyle.font.tableText,
          }}
        >
          {params.row.result}
        </Typography>
      ),
    },
    {
      field: "artefact_link",
      headerName: "Attachment",
      width: 150,
      renderCell: (params) => {
        console.log("---Attachment---", params?.row);
        return (
            <CustomButtonV2
              type={"blue-outline"}
              btnName={"View"}
              variant={"text"}
              disabled={!params?.row?.artefact_link?.length > 0}
              handleOnClick={() => {
                setSelectedTestCaseArtifactData({ ...params?.row });
                setOpenViewFilesDialog(true);
              }}
            />
        );
      },
    },
    {
      field: "executed_at_tz",
      headerName: "Executed At",
      flex: 1,
      minWidth: 120,
    },
  ];

  return (
    <Grid container>
      <Grid item sm={12} sx={{ display: "flex", justifyContent: "center" }}>
        <Box sx={{ width: "200px" }}>
          <CustomSearchFilterV2
            placeholder="Search Test Case"
            searchKeys={[
              "test_case_name",
              "run_id",
              "result",
              "manual_test_case_id",
            ]}
            getDataOnSearch={(filteredData) => {
              console.log("filteredData", filteredData);
              setFilteredTestCase(filteredData);
            }}
            inputData={tableRowsDataArtifact}
          />
        </Box>
      </Grid>
      <Box>
        <Typography
          sx={{ ...componentStyle.font.cardHeadder, fontWeight: 500 }}
        >
          Test Case Name:{" "}
          {filteredTestCase?.length > 0
            ? filteredTestCase[0]?.test_case_name || "-"
            : "-"}
        </Typography>
      </Box>
      <Grid item sm={12}>
        <Box sx={{ height: "250px" }}>
          <CustomDataGridV2
            rows={(filteredTestCase || []).slice(
              (page - 1) * rowsPerPage,
              page * rowsPerPage,
            )}
            columns={COLUMNS_ARTIFACT}
            showPagination={true}
            page={page}
            rowsPerPage={rowsPerPage}
            handlePageChange={setPage}
            totalItems={(filteredTestCase || []).length}
          />
        </Box>
      </Grid>

      <ViewImage
        open={openViewFilesDialog}
        onClose={() => setOpenViewFilesDialog(false)}
        dialogTitle="View Uploaded Files"
        selectedTestCaseData={selectedTestCaseArtifactData}
        setSelectedTestCaseData={setSelectedTestCaseArtifactData}
      />
    </Grid>
  );
}


ViewTestCaseArtifact.propTypes = {
  selectedTicketsTableRowData: PropTypes.shape({
    artefact_details: PropTypes.array
  }),
  setSelectedTicketsTableRowData: PropTypes.func
};

export default ViewTestCaseArtifact;
